import { getConfigForImportedTest, getConfigForMeasuredTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { FormatTypes } from 'Lib/Format';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';
import getLabelConfig from './labelConfig';

const lengthConfigNearest1 = { uom: 'mm', format: { nearest: 1 } };
const lengthConfig = { uom: 'mm', format: { nearest: 0.01 } };
const forceConfig = { uom: 'kN', format: { nearest: 0.01 } };
const pressureConfig = { uom: 'kN/m²', format: { type: FormatTypes.SignificantFigures, precision: 3 } };

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.LayerThickness`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.DepthOfTest`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.SeatingLoad`]: forceConfig,
      [`${prefix}.Preparation.PlateEdgeToWallDistance`]: lengthConfigNearest1,
      [`${prefix}.Preparation.CombinedEquipmentLoad`]: forceConfig,
      [`${prefix}.InitialSeatingReading.AverageReading`]: lengthConfig,
      [`${prefix}.Equipment.Balance`]: { defaultUom: 'kg', defaultReadability: 0.001 },
      [`${prefix}.Equipment.LoadCell`]: { defaultReadability: 0.01 },
      [`${prefix}.Equipment.LoadCell.Results.LoadCellFactor`]: forceConfig,
      [`${prefix}.Equipment.LoadCellFactor`]: forceConfig,
      [`${prefix}.Equipment.DisplacementGauge1`]: { defaultReadability: 0.01 },
      [`${prefix}.Equipment.DisplacementGauge2`]: { defaultReadability: 0.01 },
      [`${prefix}.Equipment.DisplacementGauge3`]: { defaultReadability: 0.01 },
      [`${prefix}.Equipment.DisplacementGauge1.Results.Factor`]: lengthConfig,
      [`${prefix}.Equipment.DisplacementGauge2.Results.Factor`]: lengthConfig,
      [`${prefix}.Equipment.DisplacementGauge3.Results.Factor`]: lengthConfig,
      [`${prefix}.Equipment.DisplacementGauge1Factor`]: lengthConfig,
      [`${prefix}.Equipment.DisplacementGauge2Factor`]: lengthConfig,
      [`${prefix}.Equipment.DisplacementGauge3Factor`]: lengthConfig,
      [`${prefix}.Equipment.Plate1.Diameter`]: lengthConfigNearest1,
      [`${prefix}.Equipment.Plate2.Diameter`]: lengthConfigNearest1,
      [`${prefix}.Equipment.Plate1.Area`]: { uom: 'm²', format: { nearest: 0.001 } },
      [`${prefix}.Equipment.Plate2.Area`]: { uom: 'm²', format: { nearest: 0.001 } },
      [`${prefix}.LoadIncrements.DesiredSettlement`]: lengthConfig,
      [`${prefix}.LoadIncrements.IncrementLoad`]: forceConfig,
      [`${prefix}.LoadIncrements.IncrementPressure`]: pressureConfig,
      [`${prefix}.LoadIncrements.Readings.ElapsedTime`]: { uom: 'min', format: { nearest: 1 } },
      [`${prefix}.LoadIncrements.Readings.AverageSettlement`]: lengthConfig,
      [`${prefix}.LabMoistureContent.MoistureContent`]: { format: { nearest: 0.1 } },
      [`${prefix}.LabMoistureContent.AssociatedMoistureContentTest.ExternalTest.Results.MoistureContentPercent`]: {
        format: { nearest: 0.1 },
      },
      ...getConfigForMeasuredTest(
        qestIds.moistureContent.BS_1377_2.rev1990,
        `${prefix}.LabMoistureContent.AssociatedMoistureContentTest`
      ),
      ...getConfigForImportedTest(
        qestIds.moistureContent.BS_1377_2.rev1990,
        `${prefix}.LabMoistureContent.AssociatedMoistureContentTest`
      ),

      [`${prefix}.Results.MaximumAppliedPressure`]: pressureConfig,
      [`${prefix}.Results.MoistureContent`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.Cycles.MaximumDeformation`]: lengthConfig,
      [`${prefix}.Results.Cycles.PressureCBRSettlement`]: pressureConfig,
      [`${prefix}.Results.Cycles.EquivalentCBR`]: { format: { type: FormatTypes.SignificantFigures, precision: 2 } },
      [`${prefix}.Results.Cycles.ModulusOfSubgradeReaction`]: { format: { nearest: 0.01 } },
    },
    getMeasuredUsingConfig(prefix),
    getLabelConfig(prefix)
  );

export default {
  [qestIds.plateLoading.InHouseMethod]: getConfig,
};
